/* ==========================================================================
   AELVITA WELLNESS — Core theme JS
   Cart drawer (Shopify AJAX API), animations, FAQ, countdown, social proof
   ========================================================================== */
(function () {
  'use strict';

  var money = function (cents) {
    return '$' + (cents / 100).toFixed(2);
  };

  /* ---------- Sticky header shadow ---------- */
  var header = document.querySelector('.site-header');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 10);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Mobile nav ---------- */
  var menuToggle = document.querySelector('.menu-toggle');
  var mobileNav = document.querySelector('.mobile-nav');
  var mobileClose = document.querySelector('.mobile-nav__close');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', function () { mobileNav.classList.add('is-open'); });
  }
  if (mobileClose) {
    mobileClose.addEventListener('click', function () { mobileNav.classList.remove('is-open'); });
  }
  if (mobileNav) {
    mobileNav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { mobileNav.classList.remove('is-open'); });
    });
  }

  /* ---------- Toast ---------- */
  var toast = document.getElementById('toast');
  window.showToast = function (msg) {
    if (!toast) return;
    toast.querySelector('.toast__msg').textContent = msg;
    toast.classList.add('is-show');
    clearTimeout(window.__toastT);
    window.__toastT = setTimeout(function () { toast.classList.remove('is-show'); }, 2600);
  };

  /* ---------- Cart drawer ---------- */
  var overlay = document.querySelector('.cart-overlay');
  var drawer = document.querySelector('.cart-drawer');
  var cartBody = document.querySelector('.cart-drawer__body');
  var cartFoot = document.querySelector('.cart-drawer__foot');
  var cartCountEls = document.querySelectorAll('.cart-count');

  window.openCart = function () {
    if (overlay) overlay.classList.add('is-open');
    if (drawer) drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  };
  window.closeCart = function () {
    if (overlay) overlay.classList.remove('is-open');
    if (drawer) drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  };
  document.querySelectorAll('[data-cart-open]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); window.openCart(); renderCart(); });
  });
  document.querySelectorAll('[data-cart-close]').forEach(function (el) {
    el.addEventListener('click', window.closeCart);
  });
  if (overlay) overlay.addEventListener('click', window.closeCart);

  function updateCartCount(count) {
    cartCountEls.forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'grid' : 'none';
    });
  }

  function renderCart() {
    if (!cartBody) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        if (!cart.items || cart.items.length === 0) {
          cartBody.innerHTML = '<div class="cart-empty"><p>Your cart is empty.</p><a href="/collections/all" class="btn btn--navy" data-cart-close>Start Shopping</a></div>';
          if (cartFoot) cartFoot.innerHTML = '';
          bindCartClose();
          return;
        }
        var html = '';
        cart.items.forEach(function (item) {
          html += '<div class="cart-line" data-key="' + item.key + '">' +
            '<img src="' + (item.image ? item.image.replace(/(\.[^.]*)$/, '_120x$1') : '') + '" alt="' + item.product_title + '">' +
            '<div class="cart-line__info"><b>' + item.product_title + '</b>' +
            '<div class="cart-line__price">' + money(item.final_price) + '</div>' +
            '<div class="cart-qty"><button data-qty-dec>&minus;</button><span>' + item.quantity + '</span><button data-qty-inc>+</button></div>' +
            '</div></div>';
        });
        cartBody.innerHTML = html;

        var upsellNote = '';
        if (cart.item_count === 1) {
          upsellNote = '<div class="cart-upsell-mini"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 12v10H4V12M2 7h20v5H2zM12 22V7M12 7H7.5a2.5 2.5 0 010-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 000-5C13 2 12 7 12 7z"/></svg> Add 1 more product & save 10% with code <b>SAVE10</b></div>';
        } else if (cart.item_count === 2) {
          upsellNote = '<div class="cart-upsell-mini"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 12v10H4V12M2 7h20v5H2zM12 22V7"/></svg> Add all 3 & save 20% with code <b>BUNDLE20</b></div>';
        }

        if (cartFoot) {
          cartFoot.innerHTML = upsellNote +
            '<div class="cart-subtotal"><span>Subtotal</span><b>' + money(cart.total_price) + '</b></div>' +
            '<a href="/checkout" class="btn btn--gold btn--block btn--lg">Secure Checkout &rarr;</a>' +
            '<p style="text-align:center;font-size:.78rem;color:var(--muted);margin:12px 0 0">🔒 Free shipping on orders $50+ · 30-day money back</p>';
        }
        bindQty();
        bindCartClose();
      })
      .catch(function () {});
  }

  function bindCartClose() {
    document.querySelectorAll('[data-cart-close]').forEach(function (el) {
      el.addEventListener('click', window.closeCart);
    });
  }

  function bindQty() {
    cartBody.querySelectorAll('.cart-line').forEach(function (line) {
      var key = line.getAttribute('data-key');
      var span = line.querySelector('.cart-qty span');
      var qty = parseInt(span.textContent, 10);
      line.querySelector('[data-qty-dec]').addEventListener('click', function () { changeQty(key, Math.max(0, qty - 1)); });
      line.querySelector('[data-qty-inc]').addEventListener('click', function () { changeQty(key, qty + 1); });
    });
  }

  function changeQty(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(function () { renderCart(); });
  }

  /* ---------- Add to cart (AJAX) ---------- */
  window.addToCart = function (variantId, quantity, btn) {
    if (!variantId) { window.showToast('Please select a product'); return; }
    var original = btn ? btn.innerHTML : '';
    if (btn) { btn.innerHTML = 'Adding…'; btn.disabled = true; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (btn) { btn.innerHTML = '✓ Added'; setTimeout(function () { btn.innerHTML = original; btn.disabled = false; }, 1400); }
        window.showToast('Added to cart');
        renderCart();
        window.openCart();
      })
      .catch(function () {
        if (btn) { btn.innerHTML = original; btn.disabled = false; }
        window.showToast('Could not add to cart');
      });
  };

  document.querySelectorAll('[data-add-to-cart]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var vid = btn.getAttribute('data-variant-id');
      var qtyInput = document.querySelector('[data-qty-input]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      window.addToCart(vid, qty, btn);
    });
  });

  /* ---------- Product form (native submit fallback) ---------- */
  document.querySelectorAll('form[action$="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var vid = form.querySelector('[name="id"]') ? form.querySelector('[name="id"]').value : null;
      var qtyInput = form.querySelector('[name="quantity"]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      var btn = form.querySelector('[type="submit"]');
      window.addToCart(vid, qty, btn);
    });
  });

  /* ---------- Quantity selectors ---------- */
  document.querySelectorAll('.qty-selector').forEach(function (sel) {
    var input = sel.querySelector('input');
    var dec = sel.querySelector('[data-dec]');
    var inc = sel.querySelector('[data-inc]');
    if (dec) dec.addEventListener('click', function () { input.value = Math.max(1, parseInt(input.value, 10) - 1); });
    if (inc) inc.addEventListener('click', function () { input.value = parseInt(input.value, 10) + 1; });
  });

  /* ---------- FAQ accordion ---------- */
  document.querySelectorAll('.faq-q').forEach(function (q) {
    q.addEventListener('click', function () {
      var item = q.closest('.faq-item');
      var answer = item.querySelector('.faq-a');
      var isOpen = item.classList.contains('is-open');
      item.classList.toggle('is-open');
      answer.style.maxHeight = isOpen ? null : answer.scrollHeight + 'px';
    });
  });

  /* ---------- Gallery thumbs ---------- */
  document.querySelectorAll('.pdp__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var main = document.querySelector('.pdp__gallery-main img');
      var src = thumb.getAttribute('data-src');
      if (main && src) main.src = src;
      document.querySelectorAll('.pdp__thumb').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  /* ---------- Countdown timer ---------- */
  document.querySelectorAll('.countdown').forEach(function (cd) {
    var end = Date.now() + (5 * 3600 + 42 * 60) * 1000; // ~5h42m from load
    var hEl = cd.querySelector('[data-h]');
    var mEl = cd.querySelector('[data-m]');
    var sEl = cd.querySelector('[data-s]');
    function tick() {
      var diff = Math.max(0, end - Date.now());
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      if (hEl) hEl.textContent = String(h).padStart(2, '0');
      if (mEl) mEl.textContent = String(m).padStart(2, '0');
      if (sEl) sEl.textContent = String(s).padStart(2, '0');
    }
    tick();
    setInterval(tick, 1000);
  });

  /* ---------- Live viewers social proof ---------- */
  document.querySelectorAll('[data-viewers]').forEach(function (el) {
    var base = 90 + Math.floor(Math.random() * 60);
    var span = el.querySelector('.viewers-num');
    function update() {
      var n = base + Math.floor(Math.random() * 14) - 6;
      if (span) span.textContent = n;
    }
    update();
    setInterval(update, 4200);
  });

  /* ---------- Scroll reveal ---------- */
  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { threshold: 0.12 });
    reveals.forEach(function (r) { io.observe(r); });
  } else {
    reveals.forEach(function (r) { r.classList.add('is-visible'); });
  }

  /* ---------- Newsletter ---------- */
  document.querySelectorAll('.footer__form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      window.showToast('Thanks! Check your inbox for 10% off.');
      form.reset();
    });
  });

  /* ---------- Init cart count on load ---------- */
  fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (cart) { updateCartCount(cart.item_count); })
    .catch(function () {});
})();
